import React, { useCallback, useRef } from "react";

import Carousel from "@storefront-core/carousel";
import ProductCard from "@storefront-core/product-card";

import { Box } from "@mui/material";

import { BASE_CARD_WIDTH_NORMAL, MOBILE_STANDARD_WIDTH, PRODUCT_COUNT } from "../../constants";
import { useScreenWidth } from "../../hooks/useScreenWidth";
import SendBrowserEvent from "../../services/sendBrowserEvent.service";
import { CarouselProps } from "../../types/interface.types";
import { Product } from "../../types/model.types";
import { getCartQuantity, getMaxOrderQuantity } from "../../utlis/cart.helper";
import DragFreeSnap from "../../utlis/embla-drag-free-snap";
import { getInStock, hasRNWebViewMessaging } from "../../utlis/helper.service";
import { useSearchRecommendations } from "../../context/SearchRecommendationContext";
import { EmblaCarouselType } from "embla-carousel";

const RecommmendatoionCarousel: React.FC<CarouselProps> = ({
  recommendation,
  productCards,
  onClickProduct,
  addToBasketClick,
  cart,
  type,
  onScroll,
  onHeaderViewAll,
  onListViewAll
}) => {
  const width = useScreenWidth();
  const isMobile = width < MOBILE_STANDARD_WIDTH;
  const BASE_CARD_WIDTH = BASE_CARD_WIDTH_NORMAL
  const { cartItem } = useSearchRecommendations();
  // const largeListCarouselSettings = {
  //   slideWidth: "200",
  //   spaceBetween: 16,
  //   freeMode: true,
  //   showNavigationArrow: !(isTablet || isMobile),
  // };
  const products = productCards ?? [];

  const defaultSettings = {
    responsive: {
      mobile: {
        gap: 1,
        slidesPerView: width / BASE_CARD_WIDTH,
        showArrow: hasRNWebViewMessaging() || isMobile ? false : true,
        showDot: false,
      },
      tablet: {
        gap: 1,
        slidesPerView: width / BASE_CARD_WIDTH,
        showArrow: hasRNWebViewMessaging() ? false : true,
        showDot: false,
      },
      laptop: { gap: 1, slidesPerView: width / BASE_CARD_WIDTH, showArrow: true, showDot: false },
      desktop: { gap: 1, slidesPerView: width / BASE_CARD_WIDTH, showArrow: true, showDot: false },
      desktopLarge: {
        gap: 1,
        slidesPerView: width / BASE_CARD_WIDTH,
        showArrow: true,
        showDot: false,
      },
    },
  };

  const handleEmblaApi = useCallback((emblaApi: EmblaCarouselType) => {
    if (!emblaApi) return;
    const handleScroll = () => onScroll?.();
    emblaApi.on("settle", handleScroll);
  }, [onScroll]);
  
  const handleQuantity = useCallback(
    (item: Product, count: number, productIndex: number) => {
      addToBasketClick?.(item, count, productIndex);
    },
    [addToBasketClick],
  );
  
  const product = products.map((item, index) => (
    <ProductCard
      id={item.id}
      key={`${item.id} ${index}`}
      image={{
        src: item?.image?.src || "",
        alt: "",
      }}
      price={item.price}
      sameDay={item?.sameDay}
      oldPrice={item?.oldPrice}
      title={item.title}
      info={item?.info}
      promotionalLabel={item?.promotionalLabel}
      deliveryTitle={item?.deliveryTitle}
      isDiscountBadge={item.isDiscountBadge}
      discountLabel={item?.discountLabel}
      discountPercent={
        typeof item.discountPercent === "number"
          ? Number(item.discountPercent.toFixed())
          : undefined
      }
      initialCartCount={getCartQuantity(item.id, cartItem)}
      onQuantityChange={(count) => handleQuantity(item, count, index)}
      onProductClick={() => onClickProduct(item,index)}
      itemSoldBy={item.itemSoldBy}
      isOutOfStock={!getInStock(item)}
      weightStep={item.raw?.weight ? Number(item.raw.weight) : undefined}
      hasRecommendation={true}
      maxQuantity={(() => {
                const cap = getMaxOrderQuantity(item);
                return Number.isFinite(cap) ? cap : undefined;
              })()}
      promotionalLabelWidth={'90%'}
    />
  ));

  const renderCarousel = () => {
    return (
      <Carousel
        emblaApiCallbackRef={handleEmblaApi}
        slides={product}
        onViewAllClick={onListViewAll}
        enableFluidContainer={true}
        containerMaxWidth={false}
        viewAllLabel={"View All"}
        enableViewAllCard={product.length > PRODUCT_COUNT}
        enableViewAll={product.length > PRODUCT_COUNT}
        settings={defaultSettings}
        plugins={[DragFreeSnap()]}
        options={{ dragFree: true, align: "start" }}
      />
    );
  };

  return <Box>{renderCarousel()}</Box>;
};

export default RecommmendatoionCarousel;
